export default "__VITE_ASSET__D2Xja_Gw__"